<template>
	<section>
		<costumHeader></costumHeader>	
		<div class="container">
		<!-- brs -->
		<br>
		<br>
		<!-- brs -->
		<h1 class="text-left">Privacy Policy</h1>
		<!-- brs -->
		<br>
		<!-- brs -->
		<h4 class="text-left">What we collect about you?</h4>
		<p class="text-left">
		For us we get your full name and username and email for now, we gonna get your cookies and explain what we get after making updates.
		</p>
		<!-- brs -->
		<br>
		<!-- <br> -->
		<h4 class="text-left">How we use your data?</h4>
		<p class="text-left">
			Your data are used to identify you in the app if you wanna be a contributor and add resources. 
		</p>
		<!-- brs -->
		<br>
		<br>
		<!-- brs -->
		<!-- <h4 class="text-left">What are those push service credentials?</h4>
		<p class="text-left">
		Push service credentials are a various values that generated by the browser (pushManager) and sent to the database if you granted the permission to the browser to send notifications, if you blocked the receiving notifications then those credentials wont be generated or the exists one is no longer be used! <br>
		Push service credentials (push service subscription) contains:<br>

		<strong>endpoint:</strong> a route used by the push service to send the notification pushed by server to the right user.<br>
		<strong>p256dh and auth:</strong> those are keys used by the push service to decrypt the notification message pushed from the server and display it to the user.<br>

		</p> -->
		<!-- brs -->
		<!-- brs -->
		<h4 class="text-left">where your data is stored?</h4>
		<p class="text-left">
		Your data stored using mongodb database (mongodb Atlas) and our database exists on Amazon web service.
		</p>
		<!-- brs -->
		<br>
		<br>
		<!-- brs -->
		<h4 class="text-left">Is your data safe?</h4>
		<p class="text-left">
		Short anwser is Yes, because if you see left of the url section above, you gonna see a small lock that means that this app uses HTTPS, so all of the application requests goes by the HTTPS Tunnel! so all of them are encypted,
		</p>
		</div>
		<!-- brs -->
		<br>
		<br>
		<!-- brs -->
		<costumFooter></costumFooter>	
	</section>
</template>

<script>

	import costumHeader from '.././components/Header.vue';
	import costumFooter from '.././components/Footer.vue';
	
	export default {

		name: 'PrivacyPolicy',

		components: {
			costumHeader,
			costumFooter
		},
		mounted(){
			window.scrollTo(0, 0);
		},
		data () {
			return {

			}
		}
	}

</script>

<style lang="css" scoped>
	.container {
		padding-top: 80px;
		margin-left: 100px; 
		margin-right: 100px; 
		font-family: var(--font--);
	}
</style>